var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.25 11.0181C0.25 5.02683 5.10691 0.169922 11.0982 0.169922H11.9018C17.8931 0.169922 22.75 5.02683 22.75 11.0181C22.75 14.3832 21.2178 17.3905 18.813 19.3803C18.3126 17.9982 17.4056 16.7877 16.2039 15.8986C14.8505 14.8972 13.197 14.3574 11.5 14.3574C9.803 14.3574 8.1495 14.8972 6.79606 15.8986C5.5944 16.7877 4.6874 17.9982 4.18701 19.3803C1.7822 17.3905 0.25 14.3832 0.25 11.0181ZM17.0565 20.4494C17.0659 20.4832 17.0769 20.516 17.0894 20.5479C15.5483 21.3886 13.7809 21.8664 11.9018 21.8664H11.0982C9.21915 21.8664 7.45166 21.3886 5.91061 20.5479C5.92312 20.516 5.93412 20.4832 5.9435 20.4494C6.26705 19.2851 6.98199 18.249 7.98566 17.5063C8.98992 16.7633 10.2252 16.3574 11.5 16.3574C12.7748 16.3574 14.0101 16.7633 15.0143 17.5063C16.018 18.249 16.733 19.2851 17.0565 20.4494ZM9.125 7.76367C9.125 6.55253 10.1537 5.50921 11.5 5.50921C12.8463 5.50921 13.875 6.55253 13.875 7.76367C13.875 8.97481 12.8463 10.0181 11.5 10.0181C10.1537 10.0181 9.125 8.97481 9.125 7.76367ZM11.5 3.50921C9.11834 3.50921 7.125 5.38003 7.125 7.76367C7.125 10.1473 9.11834 12.0181 11.5 12.0181C13.8817 12.0181 15.875 10.1473 15.875 7.76367C15.875 5.38003 13.8817 3.50921 11.5 3.50921Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerName);
export default __webpack_public_path__ + "static/media/customer_name.53d5254ee2ee46685002f5aee2b0d849.svg";
export { ForwardRef as ReactComponent };